export default function () {
  return {
    campsiteBookings: [],
    parkingBookings: [],
    gatePasses: [],
    otherCharges: []
  }
}
